import {DELETE_BANNER_ERROR, DELETE_BANNER_START, DELETE_BANNER_SUCCESS} from "../../types";

export default function delete_banner(state, action) {
    switch (action.type) {
        case DELETE_BANNER_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_BANNER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_BANNER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
